import {RoleType} from './role-type';

export enum Checker12 {
  DEPARTMENT_MANAGER = RoleType.DEPARTMENT_MANAGER,
  DEPARTMENT_DEPUTY_MANAGER = RoleType.DEPARTMENT_DEPUTY_MANAGER,
}
